interface IEnvCfg {
  version: string;
  auth_host: string;
  api_host: string;
  registerUrl: string;
  noPermissionsUrl: string;
}
export const server = import.meta.env.SERVER;
export const host = import.meta.env.HOST;
export const fcHost = import.meta.env.FC_HOSTNAME;
export const debugMode = new URL(host)?.hostname === 'localhost';
export const EnvConst: IEnvCfg = {
  version: `${import.meta.env.VERSION}`,
  auth_host: `${server}/auth`,
  api_host: `${server}/api/v1`,
  registerUrl: `${fcHost}/cred/#/sign-up`,
  noPermissionsUrl: `${fcHost}/asset`
};
export const HomeElms = {
  name: 'FortiAnalyzer',
  fcName: 'FortiAnalyzerCloud'
};
export const InstanceAction = {
  resize: 'resize',
  upgrade: 'upgrade'
};

console.info('===================const file', server, fcHost, EnvConst);
